<div class="position-relative">
	<section class="section-large section-massive-lg-up">
		<div class="filter-projects__top-bar">
			<h2 class="filter-projects__heading">{{translations['WorkbenchFiltering.Projects']}}</h2>
			<div class="filter-projects__category">
				<div class="kicker mb-2">{{translations['WorkbenchFiltering.ImLookingFor']}}:</div>
				<div class="form-group p-0 mb-3 mb-md-0">
					<select v-model="selectedCategory" name="example-select" class="custom-select custom-select--bold-huge" @change="filterRequest">
						<option v-for="category in pageData.Categories" :value="category.UrlName">{{category.DisplayTitle}}</option>
					</select>
				</div>
			</div>
			<div class="filter-projects__location">
				<div class="kicker mb-2">{{translations['WorkbenchFiltering.For']}}:</div>
				<div class="form-group p-0 mb-3 mb-md-0">
					<select v-model="selectedLocation" name="example-select" class="custom-select custom-select--bold-huge" @change="filterRequest">
						<option v-for="location in pageData.Locations" :value="location.UrlName">{{location.DisplayTitle}}</option>
					</select>
				</div>
			</div>
		</div>
		<section class="section-large section-huge-lg-up position-relative">
			<div ref="resultsWrap" class="projects-card__results-wrap" v-bind:class="[((loadingResults === true) ? 'projects-card__results-wrap--state-loading' : '')]">
				<div class="row flex-row align-items-stretch">
						<div class="col-sm-6 col-lg-4 mb-4 px-2" v-for="(project, index) in pageData.Projects" data-aos-once="true" data-aos="fade-up" :data-aos-delay="50 * index">
							<workbench-card
								:index="index"
								:baseUrl="pageData.BaseUrl"
								:urlName="project.UrlName"
								:heroImage="project.HeroImage"
								:heroImageAltText="project.HeroImageAltText"
								:ambassadorImage="project.Ambassador.Image"
								:ambassadorImageNormal="project.Ambassador.ImageNormal"
								:ambassadorImageNormalAltText="project.Ambassador.ImageNormalAltText"
								:ambassadorDisplayTitle="project.Ambassador.DisplayTitle"
								:projectTitle="project.DisplayTitle"
								:projectType="project.ArticleType"
								:difficulty="project.Difficulty"
								:time="project.Time"
								:translations="translations"
							/>
						</div>
				</div>
				<div class="load-indicator state-loading" v-if="loadingResults === true">
					<div class="load-indicator__indicator"></div>
					<span class="load-indicator__text">Loading</span>
				</div>
				<div class="load-indicator-cover" v-if="loadingResults === true"></div>
			</div>

			<div v-if="pageData.HasMoreResults === true" class="load-more" ref="loadMoreButton" @click="loadMoreResults">
				<button class="btn btn-primary load-more__btn">
					<span class="load-more__text">{{translations['WorkbenchFiltering.LoadMore']}}</span>
					<div class="load-more__indicator"></div>
				</button>
			</div>
		</section>
	</section>
</div>
